export const GET_PROVINCES_BEGIN = "GET_PROVINCE_BEGIN"
export const GET_PROVINCES_SUCCESS = "GET_PROVINCE_SUCCESS"
export const CLEAR_PROVINCE = "CLEAR_PROVINCE"